'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _blocks = require('../../blocks');

var _menuPropTypes = require('./menuPropTypes');

var _menuPropTypes2 = _interopRequireDefault(_menuPropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MenuItemTitle(_ref) {
  var TextRenderer = _ref.TextRenderer,
      expanded = _ref.expanded,
      handleExpandMenuClick = _ref.handleExpandMenuClick,
      isActive = _ref.isActive,
      isHighlighted = _ref.isHighlighted,
      isFlyout = _ref.isFlyout,
      isMenuExpanded = _ref.isMenuExpanded,
      menuItem = _ref.menuItem,
      menuGroupsLoading = _ref.menuGroupsLoading,
      menuKey = _ref.menuKey,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave;

  if (menuGroupsLoading && !isFlyout) {
    return _react2.default.createElement(
      _blocks.LeftNav.MenuItemTitle,
      { modifiers: ['ghost'] },
      _react2.default.createElement(_blocks.LeftNav.MenuItemTitleGhost, { modifiers: ['chrome200', 'icon'] }),
      expanded && _react2.default.createElement(_blocks.LeftNav.MenuItemTitleGhost, { modifiers: ['chrome200'] })
    );
  }

  return _react2.default.createElement(
    _blocks.LeftNav.MenuItemTitle,
    {
      modifiers: (0, _lodash.compact)([isHighlighted && !isFlyout && 'highlight', isActive && !isFlyout && 'active']),
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onClick: function onClick() {
        return handleExpandMenuClick(menuKey);
      }
    },
    !menuItem.url && !menuItem.path && _react2.default.createElement(
      _blocks.LeftNav.MenuItemTitleNoLink,
      {
        'aria-label': 'Navigate to ' + menuItem.url,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
      },
      !isFlyout && _react2.default.createElement(_blocks.LeftNav.MenuItemTitleIcon, {
        modifiers: (0, _lodash.compact)([!isActive && !isHighlighted && 'disabled']),
        name: menuItem.icon
      }),
      (expanded || isFlyout) && _react2.default.createElement(
        _blocks.LeftNav.MenuItemTitleText,
        {
          modifiers: (0, _lodash.compact)([isHighlighted && !isFlyout && 'highlight', isFlyout && 'flyout'])
        },
        _react2.default.createElement(TextRenderer, { message: menuItem.message })
      )
    ),
    menuItem.url && _react2.default.createElement(
      _blocks.LeftNav.MenuItemTitleA,
      {
        'aria-label': 'Navigate to ' + menuItem.url,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        href: menuItem.url,
        target: '_blank'
      },
      !isFlyout && _react2.default.createElement(_blocks.LeftNav.MenuItemTitleIcon, {
        modifiers: (0, _lodash.compact)([!isActive && !isHighlighted && 'disabled']),
        name: menuItem.icon
      }),
      (expanded || isFlyout) && _react2.default.createElement(
        _blocks.LeftNav.MenuItemTitleText,
        {
          modifiers: (0, _lodash.compact)([isHighlighted && !isFlyout && 'highlight', isFlyout && 'flyout'])
        },
        _react2.default.createElement(TextRenderer, { message: menuItem.message })
      )
    ),
    menuItem.path && _react2.default.createElement(
      _blocks.LeftNav.MenuItemTitleLink,
      {
        'aria-label': 'Navigate to ' + menuItem.path,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        to: menuItem.path
      },
      !isFlyout && _react2.default.createElement(_blocks.LeftNav.MenuItemTitleIcon, {
        modifiers: (0, _lodash.compact)([!isActive && !isHighlighted && 'disabled']),
        name: menuItem.icon
      }),
      (expanded || isFlyout) && _react2.default.createElement(
        _blocks.LeftNav.MenuItemTitleText,
        {
          modifiers: (0, _lodash.compact)([isHighlighted && !isFlyout && 'highlight', isFlyout && 'flyout'])
        },
        _react2.default.createElement(TextRenderer, { message: menuItem.message })
      )
    ),
    !isFlyout && expanded && !menuItem.url && menuItem.menuSubItems && _react2.default.createElement(_blocks.LeftNav.ExpanderButton, {
      modifiers: (0, _lodash.compact)([!isHighlighted && 'disabled']),
      name: isMenuExpanded ? 'angle-up' : 'angle-down',
      onClick: function onClick() {
        return handleExpandMenuClick(menuKey);
      }
    })
  );
}

MenuItemTitle.propTypes = {
  TextRenderer: _propTypes2.default.func.isRequired,
  expanded: _propTypes2.default.bool.isRequired,
  handleExpandMenuClick: _propTypes2.default.func.isRequired,
  isActive: _propTypes2.default.bool.isRequired,
  isFlyout: _propTypes2.default.bool,
  isHighlighted: _propTypes2.default.bool.isRequired,
  isMenuExpanded: _propTypes2.default.bool.isRequired,
  // eslint-disable-next-line react/no-typos
  menuItem: _menuPropTypes2.default.menuItem.isRequired,
  menuGroupsLoading: _propTypes2.default.bool.isRequired,
  menuKey: _propTypes2.default.string.isRequired,
  onMouseEnter: _propTypes2.default.func.isRequired,
  onMouseLeave: _propTypes2.default.func.isRequired
};

MenuItemTitle.defaultProps = {
  isFlyout: false
};

exports.default = MenuItemTitle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/LeftNav/MenuItemTitle.js
// module id = 728
// module chunks = 2